import Layout from "@/components/layout/Layout";
import QuoteForm from "@/components/QuoteForm";
import SEO from "@/components/SEO";

const Quote = () => {
  return (
    <Layout>
      <SEO title="Request a Quote · Soft Chaos Studio" description="Request a free quote for personalised handmade gifts, portraits & painted bottles." canonical="/quote" />
      <section className="bg-blush">
        <div className="container py-20">
          <h2 className="text-3xl font-serif font-semibold text-center mb-3">Request a Quote</h2>
          <p className="text-center text-muted-foreground mb-10">Tell us about your idea and we'll bring it to life.</p>
          <QuoteForm />
        </div>
      </section>
    </Layout>
  );
};

export default Quote;
